import { GradeLevelChips } from "@/search/NewSearchPageMVP/FilterPanel/filters/ReadingLevels/GradeLevelChips";
import { MaturityLevels } from "@/search/NewSearchPageMVP/FilterPanel/filters/ReadingLevels/MaturityLevelCheckboxes";
import { FilterSection } from "@/search/NewSearchPageMVP/shared/FilterSection";

interface ReadingLevelProps {
  canSeeMaturityLevels: boolean;
}

const ReadingLevels = ({ canSeeMaturityLevels }: ReadingLevelProps) => {
  return (
    <>
      <FilterSection title="Reading levels" defaultCollapsed={false}>
        <GradeLevelChips />
        {canSeeMaturityLevels && <MaturityLevels />}
      </FilterSection>
    </>
  );
};

ReadingLevels.displayName = "ReadingLevels";
export { ReadingLevels };
